import { KeyboardEvent } from "react";
import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api";
import { ISearch } from "src/components/pages/search/search.types";
import { handleLeverageProducts } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { KEY_ENTER, KEY_SPACE } from "src/consts/keyboard";

export const LeverageProductsSelection = ({ onSearch }: ISearch) => {
    const { t } = useTranslation("extended-search");

    const { leverageProductsIndication } = useSearchStore();

    const handleChange = (newIndication: string) => {
        handleLeverageProducts({
            leverageProductsIndication: Number(newIndication),
            onSearch,
        });
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>, newIndication: number) => {
        if (event.key === KEY_SPACE || event.key === KEY_ENTER) {
            event.preventDefault();
            handleChange(newIndication.toString());
        }
    };

    return (
        <RadioGroup onChange={handleChange} value={String(leverageProductsIndication)}>
            <Stack direction={["column", "row"]} spacing={3}>
                <Radio
                    tabIndex={0}
                    value={String(EnumLeverageProductsIndication.AllWikifolios)}
                    onKeyDown={event => handleKeyDown(event, EnumLeverageProductsIndication.AllWikifolios)}
                >
                    {t("all-wikifolios")}
                </Radio>
                <Radio
                    tabIndex={0}
                    value={String(EnumLeverageProductsIndication.WikifoliosWithLeverageProducts)}
                    onKeyDown={event => handleKeyDown(event, EnumLeverageProductsIndication.WikifoliosWithLeverageProducts)}
                >
                    {t("with-leverage-products")}
                </Radio>
                <Radio
                    tabIndex={0}
                    value={String(EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts)}
                    onKeyDown={event => handleKeyDown(event, EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts)}
                >
                    {t("without-leverage-products")}
                </Radio>
            </Stack>
        </RadioGroup>
    );
};
